import React, { memo, useContext, useEffect, useReducer } from 'react';
import PropTypes from 'prop-types';
import './css/Schedule1.css';
import GameWidget2 from '../../uiElements/gamesWidgets/gameWidget2/GameWidget2';
import Spinner1 from '../../uiElements/spinners/spinner1/Spinner1';
import { context } from '../../../globalState/GlobalState';
import { getLocalTimeFromDatabaseTime, getMonthYearStringFromDate } from '../../../catalog/DateTime';
import PlaceholderComponent2 from '../../uiElements/placeholderComponents/placeholderComponent2/PlaceholderComponent2';
import AdComponent1 from '../../uiElements/adComponents/adComponent1/AdComponent1';
import { isValidObject } from '../../../catalog/Validity';

const initialState = {
    monthIndexes: [],
};

function reducer(state, action) {
    switch (action.type) {
        case 'setMonthIndexes':
            return { ...state, monthIndexes: action.indexes };
        default:
            return initialState;
    }
}

const ScheduleGames1 = (props) => {
    const { games, loadingSpinner, scheduled, unavailableText } = props;
    const [state, setState] = useReducer(reducer, initialState);
    const { globalState } = useContext(context);

    useEffect(() => {
        const monthIndexes = [];

        games.forEach((_, index) => {
            if (index + 1 < games.length && isValidObject(insertMonth(games[index + 1], index + 1))) {
                monthIndexes.push(index);
            }
        });

        setState({ type: 'setMonthIndexes', indexes: monthIndexes });
    }, [games]);

    const insertMonth = (game, index) => {
        if (index === 0) {
            return <h2 className="schedule1-games-month-title text-left-align font-size-2xl m-t-0 m-b-20px text-uppercase">{getMonthYearStringFromDate(getLocalTimeFromDatabaseTime(game.timeOfGame))}</h2>;
        }
        if ((getLocalTimeFromDatabaseTime(game.timeOfGame).getFullYear() === 2099 || getLocalTimeFromDatabaseTime(game.timeOfGame).getFullYear() === 2100) && (getLocalTimeFromDatabaseTime(game.timeOfGame).getMonth() !== getLocalTimeFromDatabaseTime(games[index - 1].timeOfGame).getMonth() || getLocalTimeFromDatabaseTime(game.timeOfGame).getFullYear() !== getLocalTimeFromDatabaseTime(games[index - 1].timeOfGame).getFullYear())) {
            return <h2 className="schedule1-games-month-title text-left-align font-size-2xl m-t-20px m-b-20px text-uppercase">TBA</h2>;
        }
        if (getLocalTimeFromDatabaseTime(game.timeOfGame).getMonth() !== getLocalTimeFromDatabaseTime(games[index - 1].timeOfGame).getMonth() || getLocalTimeFromDatabaseTime(game.timeOfGame).getFullYear() !== getLocalTimeFromDatabaseTime(games[index - 1].timeOfGame).getFullYear()) {
            return <h2 className="schedule1-games-month-title text-left-align font-size-2xl m-t-20px m-b-20px text-uppercase">{getMonthYearStringFromDate(getLocalTimeFromDatabaseTime(game.timeOfGame))}</h2>;
        }
        return null;
    };

    const getAdComponent = (game, monthIndex) => {
        if (state.monthIndexes.includes(monthIndex)) {
            const index = state.monthIndexes.indexOf(monthIndex);
            if (index > 0 && state.monthIndexes[index] - state.monthIndexes[index - 1] < 3) {
                return null;
            }
            if (index % 5 === 4) {
                return (
                    <AdComponent1
                        showDesktop
                        showMobile
                        mobileSizes={['smartphone1', 'smartphone2', 'halfBanner', 'medRec', 'square', 'largeRec']}
                        desktopContainerId={`ads-container-${game.id}`}
                        mobileContainerId={`ads-container-${game.id}`}
                        placementId="schedule"
                    />
                );
            }
            return (
                <AdComponent1
                    showDesktop
                    showMobile
                    desktopContainerId={`ads-container-${game.id}`}
                    mobileContainerId={`ads-container-${game.id}`}
                    placementId="schedule"
                />
            );
        }

        return null;
    };

    const getLastAdComponent = () => {
        if (state.monthIndexes > 0 && games.length - state.monthIndexes[-1] > 2) {
            return (
                <AdComponent1
                    showDesktop
                    showMobile
                    mobileSizes={['smartphone1', 'smartphone2', 'halfBanner', 'medRec', 'square', 'largeRec']}
                    desktopContainerId="ads-container-schedule"
                    mobileContainerId="ads-container-schedule"
                    placementId="schedule"
                />
            );
        }

        return null;
    };

    return (
        <div className="schedule1-games full-width">
            {loadingSpinner ? (<Spinner1 color={globalState.websiteStyles.colors.primaryColor} />) : (
                <>
                    {games.length > 0 ? (
                        <>
                            {games.map((game, index) => {
                                return (
                                    <div key={game.id}>
                                        {insertMonth(game, index)}
                                        <GameWidget2 id={game.id} game={game} opponentName={game.opponentName} opponentLogo={game.opponentLogo} scheduled={scheduled} homeGame={game.homeGame} status={game.status} timeOfGame={game.timeOfGame} venue={game.venue} />
                                        { getAdComponent(game, index) }
                                    </div>
                                );
                            })}
                            {getLastAdComponent()}
                        </>
                    ) : (<PlaceholderComponent2 text={unavailableText} />)}
                </>
            )}
        </div>
    );
};

ScheduleGames1.propTypes = {
    games: PropTypes.array.isRequired,
    loadingSpinner: PropTypes.bool.isRequired,
    scheduled: PropTypes.bool.isRequired,
    unavailableText: PropTypes.string.isRequired,
};

export default memo(ScheduleGames1);
